




























































































































































import Vue from "vue";
import moment from "moment";
import { mapGetters } from "vuex";

import DeviceTree from "@/components/DeviceTree/index.vue";

import { MODULE_COLORS } from "@/utility/Constants";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";
import { CaosConfigurationTemplate } from "@/model/data/caosConfiguration/CaosConfigurationTemplate";
import { CheckTemplateVersionCommand, CheckTemplateVersionReqData } from "@/model/communication/caosConfiguration/CheckTemplateVersionCommand";
import {
    PollCaosConfigurationUpdateStatusCommand,
    PollCaosConfigurationUpdateStatusReqData,
} from "@/model/communication/caosConfiguration/PollCaosConfigurationUpdateStatusCommand";
import { PollCaosConfigurationUpdateStatusResData } from "@/model/communication/caosConfiguration/PollCaosConfigurationUpdateStatusResData";
import { CheckTemplateVersionResData } from "@/model/communication/caosConfiguration/CheckTemplateVersionResData";
import { ApplyTemplateCommand, ApplyTemplateReqData } from "@/model/communication/caosConfiguration/ApplyTemplateCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ApiGenericResponse } from "@/model/communication/ApiGenericResponse";
import VFaIcon from "@/components/VFaIcon.vue";

export default Vue.extend({
    props: { showDialog: Boolean, template: CaosConfigurationTemplate, loading: Boolean },
    components: {
        DeviceTree,
        VFaIcon,
    },
    data() {
        return {
            moment,
            MODULE_COLORS,
            step: 1,
            templateInstallations: [],
            reload: 0,
            allowedInstallations: [],
            notAllowedInstallations: [],
            loadingCheckVersion: false,
            loadingApplyTemplate: false,
            templateNotApplicable: false,
            startDateTime: null,
            updatedInstallation: null,
            finishedCount: 0,
        };
    },
    computed: {
        ...mapGetters(["longDateFormat"]),

        showForceTemplateDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog", newValue);
                this.step = 1;
                this.templateInstallations = [];
                this.reload += 1;
                this.templateNotApplicable = false;
            },
        },
        canContinue() {
            return this.templateInstallations && this.templateInstallations.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).length > 0 && !this.templateNotApplicable;
        },
    },
    methods: {
        continueStep() {
            if (this.step == 1) {
                this.sendRequestCheckVersion();
            } else if (this.step == 2) {
                this.sendRequestApplyTemplate();
            } else if (this.step == 3) {
                this.showForceTemplateDialog = false;
                return;
            }
            this.step += 1;
        },
        backStep() {
            if (this.step == 2) {
                this.templateNotApplicable = false;
            }
            this.step -= 1;
        },
        async sendRequestCheckVersion() {
            this.loadingCheckVersion = true;
            let reqData = new CheckTemplateVersionReqData(
                this.templateInstallations.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).map((l) => l.name),
                this.template.id
            );
            let response: CheckTemplateVersionResData = await new CheckTemplateVersionCommand(reqData).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                this.allowedInstallations = response.allowedInstallations;
                this.notAllowedInstallations = response.notAllowedInstallations;
                if (!this.allowedInstallations || !this.allowedInstallations.length) this.templateNotApplicable = true;
            }
            this.loadingCheckVersion = false;
        },

        async sendRequestApplyTemplate() {
            this.loadingApplyTemplate = true;
            let reqData = new ApplyTemplateReqData(this.allowedInstallations, this.template.id);
            let response: ApiGenericResponse = await new ApplyTemplateCommand(reqData).execute();
            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                this.startDateTime = moment.utc();
                this.updatedInstallation = [];
                this.allowedInstallations.forEach((inst) => {
                    this.updatedInstallation.push({ name: inst, result: 0, error: "", finish: false });
                });
                setTimeout(this.finalStatusPolling, 10000);
            }
            this.loadingApplyTemplate = false;
        },

        async finalStatusPolling() {
            let reqData = new PollCaosConfigurationUpdateStatusReqData(this.allowedInstallations);
            let response: PollCaosConfigurationUpdateStatusResData = await new PollCaosConfigurationUpdateStatusCommand(reqData).execute();
            console.log(response);
            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                response.installationsUpdateIsFinished.forEach((value: number, installationName: string) => {
                    if (value != null || value != undefined) {
                        let index = this.updatedInstallation.findIndex((i) => i.name == installationName);
                        //si usa $set se no vue non è reattivo
                        this.$set(this.updatedInstallation, index, { name: installationName, result: value, finish: true, error: this.$t(`notifications.result_code.${value}`) });
                        this.finishedCount += 1;
                    }
                });
            }
            if (this.finishedCount < this.allowedInstallations.length) {
                console.log("Force template wizard: send poll");
                setTimeout(this.finalStatusPolling, 10000);
            }
        },
    },
});
